import { createStore, combineReducers } from "redux";

import AppReducer from './AppReducer'

const combineReducer = combineReducers({
    app: AppReducer,
});

let token = localStorage.getItem('USER_TOKEN');
let id = null;

if (token != null) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    var tmp = JSON.parse(window.atob(base64));

    id = tmp['id'];
}

export const allReducer = createStore(
    combineReducer,
    {
        app: {
            token: token,
            id: id,
            dns: "https://api2mt.mytravo.net",
            version: "v2",
        },
    },
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);


// WEBPACK FOOTER //
// ./src/reducers/index.js